import React from "react";
import "./index.scss";
import {Typography} from "antd";
import { useTranslation } from "react-i18next";

const {Text} = Typography;

const EmptyData = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div className="empty-data">
      <Text>{message || t("no_finished_round")}</Text>
    </div>
  );
};

export default EmptyData;

